const fixedTopHeight = () => Math.max(0, ...[...document.querySelectorAll('#wpadminbar, header')].map(el => {
  const rect = el.getBoundingClientRect();
  const pinned = ['fixed', 'sticky'].includes(getComputedStyle(el).position);

  return pinned && rect.height && rect.bottom < innerHeight / 2 && rect.right > 0 && rect.left < innerWidth ? rect.bottom : 0;
}));

export function scrollBelowFixedHeader(el) {
  window.scrollTo({
    top: el.getBoundingClientRect().top + window.scrollY - fixedTopHeight() - 16,
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
  });
}
